import { Flex, InfoIcon, Text } from "@fluentui/react-northstar";
import styled from "styled-components";

const ArchivedTextIntoDialog = () => {
    return (
        <BackgroundFlex>
            <Flex gap="gap.small" vAlign="center">
                <InfoIcon />
                <Text
                    styles={{
                        fontWeight: "600",
                        fontSize: "14px",
                    }}
                    content="Le changement de statut aura des conséquences sur le collaborateur : "
                />
            </Flex>
            <Flex
                styles={{
                    marginLeft: "30px",
                    marginTop: "16px",
                    fontSize: "14px",
                    fontWeight: "600",
                    lineHeight: "20px",
                }}
                column
            >
                <ul>
                    <li>Plus de connexion possible à Yeetch</li>
                    <li>Archivage de la liste de tâches</li>
                    <li>
                        Réinitialisation de tous les soldes (vacances,
                        récupération, congés payés...)
                    </li>
                    <li>Il ne sera plus visible dans l’outil </li>
                </ul>
            </Flex>
        </BackgroundFlex>
    );
};
export default ArchivedTextIntoDialog;

const BackgroundFlex = styled.div`
    border-radius: 4px;
    border: 1px solid var(--Light-theme-Rest-Border-Default-Border, #d1d1d1);
    background: var(
        --Light-theme-Rest-Background-Default-Background-5,
        #e0e0e0
    );
    padding: 6px 0px 6px 16px;
    align-items: center;
    gap: 4px;
`;
